import React from 'react';
import { LinkListType } from '../../../../../types/globalSettingsType';
import { MegaMenuSectionHeader } from '../MenuSectionHeader/MenuSectionHeader';
import { MenuLinkList } from '../MenuLinkList/MenuLinkList';
import * as S from './MenuSection.styles';

interface MenuSectionProps {
  megaMenuSection?: LinkListType | null;
}

const MenuSection = ({ megaMenuSection }: MenuSectionProps) => {
  if (!megaMenuSection || typeof megaMenuSection !== 'object' || !Array.isArray(megaMenuSection.links)) return null;

  return (
    <S.Wrapper>
      {megaMenuSection.headerLink && (
        <MegaMenuSectionHeader header={megaMenuSection.header} link={megaMenuSection.headerLink} />
      )}
      <S.StyledList>
        {megaMenuSection.links.map((link, i) => (
          <MenuLinkList key={link?.key ?? i} link={link} megaMenuSectionName={megaMenuSection.header} />
        ))}
      </S.StyledList>
    </S.Wrapper>
  );
};

export default MenuSection;
